<template>
    <div class="my-prize" v-if="showing">

      <div>
        <modal-mask></modal-mask>
      </div>

      <div v-if="prizeInfo.length > 0" class="my-prize-normal" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
        <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
        <div class="head-font" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">中奖记录</div>
        <div class="my-prize-content">
          <div v-for="(item, idx) in prizeInfo" :key="idx" class="prize-item" :style="`background: ${h5ConfigDetails[0]['fontColor']['myPrizeBlockBg'][0]};`">
            <div v-if="item.couponContent">
              <div class="prize-icon">
                <img v-if="h5ConfigDetails" :src="`${item.prizeImg}`" alt="">
              </div>
              <div class="normal-prize-info">
                <div class="prize-line">
                  <p class="prize-title" :style="{width: item.gameName.indexOf('Q币') !== -1 ? '' : '20rem',color:h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]}">{{item.couponDescription}}</p>
                  <img v-if="item.cdkStatus !== undefined" class="cdk-status" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['qbStatusImg'][item.cdkStatusTxt]}`" alt="">
                </div>
                <div v-if="item.gameName.indexOf('链接') === -1" class="prize-content" :style="`background: ${h5ConfigDetails[0]['fontColor']['cdkBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">
                  <div class="prize-content-code">
                    <span>兑换码：</span>
                    <span class="coupon-code">{{$_isXunMengTu() ? item.couponContent.split("_")[0] : item.couponContent}}</span>
                  </div>
                   <span v-if="item.cdkStatus !== undefined" class="prize-content-copy" @click="_show_exchange_cdk(item.cdkStatus, item.couponContent, item.qqNum)" :style="`background: ${h5ConfigDetails[0]['fontColor']['smallBtnBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['smallBtnTxtColor'][0]};`">{{item.cdkBtnTxt}}</span>
                  <span v-else class="prize-content-copy" @click="_copy_code(item.couponContent)" :style="`background: ${h5ConfigDetails[0]['fontColor']['smallBtnBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['smallBtnTxtColor'][0]};`">复制</span>
                </div>
                <div v-else class="link-jump" @click="_link_jump(item.couponContent)" :style="`background: ${h5ConfigDetails[0]['fontColor']['smallBtnBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['smallBtnTxtColor'][0]};`">点击兑换</div>
                <p class="prize-create-time" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">{{$_timestampLocalStr(new Date(JSON.parse(item.timestamp)))}}</p>
                <p class="how-touse" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">{{item.howToUse}}</p>
              </div>
            </div>
            <!-- 无奖品礼包中奖历史展示 -->
            <div v-else-if="item.couponType == 2 && item.packageSize == 0 && item.awardDuration == 0" class="no-prize-item">
              <div class="prize-icon">
                <img v-if="h5ConfigDetails" :src="`${item.prizeImg}`" alt="">
              </div>
              <div class="no-prize-info">
                <div>
                  <p class="prize-name" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">{{item.couponDescription}}</p>
                  <p class="prize-create-time" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">{{$_timestampLocalStr(new Date(JSON.parse(item.timestamp)))}}</p>
                </div>
                <div class="prize-content-copy" @click="_show_vain_win(item.createTime)" :style="`background: ${h5ConfigDetails[0]['fontColor']['smallBtnBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['smallBtnTxtColor'][0]};`">查看</div>
              </div>
            </div>
            <div v-else>
              <div class="prize-icon">
                <img v-if="h5ConfigDetails" :src="`${item.prizeImg}`" alt="">
              </div>
              <div class="normal-prize-info">
                <p class="prize-name" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">{{item.couponDescription}}</p>
                <p class="prize-create-time" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">{{$_timestampLocalStr(new Date(JSON.parse(item.timestamp)))}}</p>
                <p class="how-touse" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">{{item.howToUse}}</p>
                <div v-if="item.gameName.indexOf('AI') !== -1" class="ai-jump" @click="_ai_jump()" :style="`background: ${h5ConfigDetails[0]['fontColor']['smallBtnBg'][0]};color: ${h5ConfigDetails[0]['fontColor']['smallBtnTxtColor'][0]};`">查看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="my-prize-empty" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
        <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
        <div class="head-font" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">中奖记录</div>
        <img class="empty-list" :src="require('@/assets/modal/prize_empty.png')" alt="">
        <div class="empty-desc" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">暂无奖品</div>
        <div class="prize-empty-desc" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">买会员领奖品呀</div>
      </div>
    </div>
</template>

<script>
import ModalMask from '@/components/modal/ModalMask'
import { baseUrl } from '@/config/env'
import { mapState } from 'vuex'
import appBridge from '@/config/appBridge'
import PopWinInstance from '@/components/modal/VainWin/index.js'

export default {
  name: 'MyPrize',
  components: {
    ModalMask
  },
  data () {
    return {
      baseUrl,
      showing: false,
      prizeInfo: []
    }
  },
  computed: {
    ...mapState(['isInIos', 'h5ConfigImgPath', 'h5ConfigDetails'])
  },
  mounted () {
  },
  methods: {
    show (prizeHis) {
      this.showing = true
      this.prizeInfo = prizeHis
      console.log(this.h5ConfigDetails)
    },
    _close () {
      this.showing = false
    },
    _copy_code (content) {
      if (this.isInIos) {
        window.webkit.messageHandlers.Share.postMessage({
          eventName: 'copy_entrycode',
          content: content,
          toastText: '复制成功'
        })
      } else {
        var input = document.createElement('input')
        input.setAttribute('value', content)
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        document.execCommand('copy')
        this.$toast('复制成功', 3000)
      }
    },
    _link_jump (link) {
      appBridge.turnToWeb(link)
    },
    _ai_jump () {
      appBridge.turnToAI()
    },
    _show_vain_win (createTime) {
      this.showing = false

      new PopWinInstance(createTime % this.h5ConfigDetails[0]['vainPicture']['vainPopImg'].length)
    },
    _show_exchange_cdk (cdkStatus, code, qqNum) {
      this.showing = false
      cdkStatus === 0 || cdkStatus === 3 ? this.$parent.$refs.exchangeCode.show(code) : this.$parent.$refs.CDKInfo.show(code, qqNum)
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .my-prize-normal, .my-prize-empty {
    text-align: center;
    background-color: @modal-bg-color;
    .modal-common;
  }

  .my-prize-normal {
    width: 29.7rem;
    height: 35.5rem;
  }

  .my-prize-empty {
    width: 29.7rem;
    height: 21.1rem;
  }

  .head-font {
    font-size: 1.8rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #7E3E1B;
    line-height: 2.6rem;
    margin: 1.67rem auto;
  }

  .empty-desc {
    font-size: 1.47rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #A9420B;
    line-height: 2rem;
    margin-bottom: 0.67rem;
  }

  .prize-empty-desc {
    font-size: 1.33rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #A9420B;
    line-height: 1.87rem;
  }

  .my-prize-content {
    height: 27rem;
    overflow-y: scroll;
    padding: 0 0.8rem 0 1rem;
    margin-right: 0.7rem;
  }

  .my-prize-content::-webkit-scrollbar{
    -webkit-appearance: none;
  }

  .my-prize-content::-webkit-scrollbar:vertical{
    width:.2rem;
  }

  .my-prize-content::-webkit-scrollbar-thumb{
    border: 1px solid #FADFAF;
    border-radius: .9rem;
    background-color: #FADFAF;
  }

  .empty-list {
    width: 9.2rem;
    height: auto;
  }

  .prize-item {
    width: 27rem;
    position: relative;
    margin: 0 auto 1rem;
    border-radius: .9rem;
    background: #FDEDD6;
  }

  .prize-item > div {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: self-start;
    padding-right: 0.9rem;
  }

  .prize-icon {
    width: 5.4rem;
    height: auto;
    margin-top: 0.7rem;
    flex-shrink: 0;
  }

  .prize-icon img {
    width: 100%;
  }

  .prize-content {
    width: 100%;
    height: 1.53rem;
    background: #FFE3BA;
    font-size: .9rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A9420B;
    line-height: 1.1rem;
    border-radius: 0.4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.7rem;
    padding-left: 0.5rem;
  }

  .prize-content-copy {
    padding: 0 1rem;
    height: 1.5rem;
    background: linear-gradient(90deg, #FF8250 0%, #FF4C59 100%);
    border-radius: 0.8rem;
    font-size: 0.93rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1.5rem;
    text-align: center;
  }

  .normal-prize-info {
    // position: relative;
    margin-left: .23rem;
    text-align: left;
    width: 100%;
    .prize-line{
      display: flex;
      align-items: center;
      margin: 1rem 0 0.7rem 0;
      justify-content: space-between;
      .prize-title{
        font-size: 1.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #A9420B;
        line-height: 1.4rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 14rem;
      }
      .cdk-status{
        height: 1.67rem;
        width: auto;
      }
    }
    .link-jump{
      position: absolute;
      right: .9rem;
      top: 1.8rem;
      padding: 0 1rem;
      height: 1.5rem;
      background: linear-gradient(90deg, #FF8250 0%, #FF4C59 100%);
      border-radius: 0.8rem;
      font-size: 0.93rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 1.5rem;
      text-align: center;
    }
  }

  .no-prize-item {
    align-items: center !important;
    .prize-icon {
      margin-top: 0;
      width: 5.4rem;
      height: auto;
      flex-shrink: 0;
    }
    .no-prize-info {
      width: 21rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      margin-left: 0.23rem;
      .prize-name {
        width: auto;
        font-size: 1.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        line-height: 1.4rem;
        margin: 1rem 0 0.7rem 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .prize-create-time {
        margin-bottom: 1rem;
      }
    }
  }

  .prize-content-code {
    display: flex;
  }

  .coupon-code {
    width: 10rem;
    overflow-x: hidden;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .prize-name {
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #A9420B;
    line-height: 1.4rem;
    margin: 1rem 0 0.7rem 0;
    width: 20rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  // .cdk-status {
  //   width: 5rem;
  //   height: 1.4rem;
  //   line-height: 1.4rem;
  //   position: absolute;
  //   right: -.3rem;
  //   top: -.1rem;
  //   font-size: 1rem;
  //   transform: scale(.9);
  //   text-align: center;
  //   border-radius: 0 0.7rem 0 0.7rem;
  //   font-size: 1.1rem;
  // }

  .how-touse {
    font-size: 1.07rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #B7704A;
    line-height: 1.07rem;
    margin-bottom: 1rem;
  }

  .ai-jump{
    position: absolute;
    right: .9rem;
    top: 2.6rem;
    padding: 0 1rem;
    height: 1.5rem;
    background: linear-gradient(90deg, #FF8250 0%, #FF4C59 100%);
    border-radius: 0.8rem;
    font-size: 0.93rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1.5rem;
    text-align: center;
  }

  .prize-create-time {
    font-size: 1.07rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #B7704A;
    line-height: 1.07rem;
    margin-bottom: 0.67rem;
  }
</style>
